import React from 'react'
import { Link } from 'react-router-dom';

 const CallToActionContainer = ({ containerObject, dataZone, templateName, contentId }) => {
    var content = containerObject;
  
  
    return (
    <div  data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row `}>
      {/* <!--cat subscribe start--> */}
        <section class="cta-subscribe pt-60 pb-120 ">
            <div class="container">
                <div class="bg-gradient ptb-120 position-relative overflow-hidden rounded-custom">
                    <div class="row justify-content-center">
                        <div class="col-lg-7 col-md-8">
                            <div class="subscribe-info-wrap text-center position-relative z-2">
                                <div class="section-heading">
                                    <h4 class="h5 text-warning" dangerouslySetInnerHTML={{ __html: content.containerTitle }}></h4>
                                    <h2 dangerouslySetInnerHTML={{ __html: content.containerSubTitle }}></h2>
                                    <p dangerouslySetInnerHTML={{ __html: content.containerBody }}></p>
                                </div>
                                <div class="form-block-banner mw-60 m-auto mt-5">
                                    <Link to="contact-us.html" class="btn btn-primary" > {content.attributes.containerButton}</Link>
                                    
                                </div>
                                <ul class="nav justify-content-center subscribe-feature-list mt-4">
                                    <li class="nav-item">
                                        <span><i class="far fa-check-circle text-primary me-2"></i> {content.attributes.containerMenuA} </span>
                                    </li>
                                    <li class="nav-item">
                                        <span><i
                                        class="far fa-check-circle text-primary me-2" ></i> {content.attributes.containerMenuB}</span>
                                    </li>
                                    <li class="nav-item">
                                        <span><i class="far fa-check-circle text-primary me-2" ></i> {content.attributes.containerMenuC}</span>
                                    </li>
                                    <li class="nav-item">
                                        <span><i class="far fa-check-circle text-primary me-2" ></i> {content.attributes.containerMenuD}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="bg-circle rounded-circle circle-shape-3 position-absolute bg-dark-light left-5"></div>
                    <div class="bg-circle rounded-circle circle-shape-1 position-absolute bg-warning right-5"></div>
                </div>
            </div>
        </section>
        {/* <!--cat subscribe end--> */}
     </div>
  
  )
}
export default CallToActionContainer